import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useTranslations } from "next-intl";
import { UiLegacy } from "@silvertours/front-legacy-shared";
import { Ui } from "@silvertours/front-shared";
import { LinksList, LinkItem } from "./RentalCompaniesLinks.styles";
var RentalCompaniesLinks = function() {
    var t = useTranslations("features.rentalCompaniesLinksLegacy");
    var links = t.raw("links");
    if (!links) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(UiLegacy.SectionTitle, {
                children: t("title")
            }),
            /*#__PURE__*/ _jsx(LinksList, {
                children: links.map(function(link) {
                    return /*#__PURE__*/ _jsxs(LinkItem, {
                        children: [
                            /*#__PURE__*/ _jsx(UiLegacy.Rating, {
                                value: link.rating
                            }),
                            /*#__PURE__*/ _jsx(Ui.TextLink, {
                                href: link.href,
                                text: link.text
                            })
                        ]
                    }, link.href);
                })
            })
        ]
    });
};
export { RentalCompaniesLinks };
